module.exports = __webpack_public_path__ + "static/img/KR@3x.1317f882.jpg";